import React, { useState, createContext } from "react";
import { IAddUpdateLocationForm, IFormFieldsValid } from "../../interfaces/interface";

export const AddUpdateLocationContext = createContext<any>({});

export const AddUpdateLocationProvider: React.FC = (props) => {
    const [file, setFile] = useState<File | undefined>(undefined)
    const [errorMessage, setErrorMessage] = useState<string>("")
    const [isFileJson, setIsFileJson] = useState<boolean>(true)
    const [formInput, setFormInput] = useState<IAddUpdateLocationForm>({
        fileData: "",
        fileNamesList: [],
        locationType: "",
      });
      const [formFieldsValid, setFormFieldsValid] = useState<IFormFieldsValid>({
        isValid:false,
        displayMessage: false,
        message: ""
    })
    const [defaultSelect, setDefaultSelect] = useState<string>("")
  return (
    <AddUpdateLocationContext.Provider
      value={{
        Form: [formInput, setFormInput],
        FileData: [file, setFile],
        formVal: [formFieldsValid, setFormFieldsValid],
        errMessage: [errorMessage, setErrorMessage],
        selectDefault: [defaultSelect, setDefaultSelect],
        isJson:[isFileJson, setIsFileJson],
      }}
    >
      {props.children}
    </AddUpdateLocationContext.Provider>
  );
};
